import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["input", "editor"]

    connect() {
        // Block file drops/paste images entirely
        this.element.addEventListener("trix-file-accept", (e) => {
            e.preventDefault()
        })

        this.element.addEventListener("trix-attachment-add", (e) => {
            // If somehow an attachment sneaks in (e.g., paste), remove it.
            const attachment = e.attachment
            if (attachment && (attachment.file || attachment.getURL())) {
                e.preventDefault()
                attachment.remove()
            }
        })
    }
}
